function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useNavigationListContext } from "@sprout/list-navigation";
import { useCallback, useMemo } from "react";
import { ItemType } from "sprout-graphql";
import { Box } from "sprout-ui-primitives";
import { usePostPageEditor } from "../PostPageEditorContext";
import { PostPageTodoEditor } from "../PostPageEditors";
import PostPageTodoListTitle from "./PostPageTodoListTitle";
import PostPageTodoListRatio from "./PostPageTodoListRatio";
import PostPageTodoListTodosIncomplete from "./PostPageTodoListTodosIncomplete";
import PostPageTodoListTodosCompleted from "./PostPageTodoListTodosCompleted";
import PostPageTodoListNewButton from "./PostPageTodoListNewButton";
const PostPageTodoList = (props)=>{
    var ref;
    const { dragProvided , todoList , disabled , pressToEdit , navigationListItemProvided , todoSupportedActions , todoSingularAction ,  } = props;
    const { id , nodeId  } = todoList;
    const todos = todoList.todos.nodes;
    const completedTodos = useMemo(()=>{
        return todos.filter((x)=>x.completed && !(x.isExplicitlyArchived || x.isExplicitlyDeleted)).sort((a, b)=>{
            return new Date(b.completedAt).getTime() - new Date(a.completedAt).getTime();
        });
    }, [
        todos
    ]);
    const incompleteTodos = useMemo(()=>{
        return todos.filter((x)=>!x.completed && !(x.isExplicitlyArchived || x.isExplicitlyDeleted));
    }, [
        todos
    ]);
    const { state  } = usePostPageEditor();
    const openTodoNewEditor = state.editor === "CREATE_TODO" && state.editorPosition === id;
    // eslint-disable-next-line @typescript-eslint/unbound-method
    const { dispatchCommand  } = useNavigationListContext();
    const archiveTodoList = useCallback(()=>{
        dispatchCommand("ARCHIVE", todoList);
    }, [
        dispatchCommand,
        todoList
    ]);
    return /*#__PURE__*/ _jsxs(Box, _objectSpread({
        /**
       * Use padding here, so that the space is accounted by `rb-dnd` to prevent
       * the jitter effect.
       */ pb: 5,
        // eslint-disable-next-line @typescript-eslint/unbound-method
        ref: dragProvided === null || dragProvided === void 0 ? void 0 : dragProvided.innerRef
    }, dragProvided && _objectSpread({}, dragProvided.draggableProps, dragProvided.dragHandleProps), {
        children: [
            todos.length !== 0 && /*#__PURE__*/ _jsx(PostPageTodoListRatio, {
                completedCount: completedTodos.length,
                totalCount: todos.length,
                disabled: disabled,
                onArchive: archiveTodoList,
                pressToEdit: pressToEdit
            }),
            /*#__PURE__*/ _jsx(PostPageTodoListTitle, {
                disabled: disabled,
                todoList: todoList,
                navigationListItemProvided: navigationListItemProvided,
                pressToEdit: pressToEdit
            }),
            /*#__PURE__*/ _jsx(PostPageTodoListTodosIncomplete, {
                postId: (ref = todoList.rootTopicOrSelf) === null || ref === void 0 ? void 0 : ref.id,
                parentId: id,
                parentNodeId: nodeId,
                disabled: disabled,
                todos: incompleteTodos,
                parentType: ItemType.Checklist,
                todoSingularAction: todoSingularAction,
                todoSupportedActions: todoSupportedActions,
                /**
         * `prepend` is a MUST if you want to use `setActiveItemId` correctly.
         *
         * `setActiveItemId` is used by `PostPageTodoEditor` to focus the newly
         * created `TODO`.
         *
         * This is due to how the `ListNavigation` context works, `setActiveItemId`
         * must be called under the `Provider` of the `activeItemId` it wants to set.
         */ prepend: /*#__PURE__*/ _jsx(PostPageTodoEditor, {
                    open: openTodoNewEditor ? state.variant : undefined,
                    parentId: id,
                    parentNodeId: nodeId,
                    parentType: ItemType.Checklist,
                    afterItemId: null,
                    topicId: id
                })
            }),
            /*#__PURE__*/ _jsx(PostPageTodoListNewButton, {
                todoListId: id,
                todoListNodeId: nodeId
            }),
            /*#__PURE__*/ _jsx(PostPageTodoListTodosCompleted, {
                parentId: id,
                disabled: disabled,
                todos: completedTodos,
                todoSingularAction: todoSingularAction,
                todoSupportedActions: todoSupportedActions
            })
        ]
    }));
};
export default PostPageTodoList;
